import { OverlayRef } from '@angular/cdk/overlay';
import { EventEmitter } from '@angular/core';

import { PopupTooltipConfig } from './popup-tooltip-config';

export enum PopupTooltipCloseEventType
{
    Outside = -1,
    TimeOut = 0,
    Clicked = 1
}

export class PopupTooltipRef
{
    public closeEvent: EventEmitter<PopupTooltipCloseEventType> = new EventEmitter<PopupTooltipCloseEventType>();
    private intervalId: NodeJS.Timeout;

    get isVisible (): boolean
    {
        return this.overlayRef && this.overlayRef.overlayElement !== null;
    }

    constructor (
        public readonly overlayRef: OverlayRef,
        public config: PopupTooltipConfig
    )
    {
        // this.intervalId = setTimeout(() => this.destroy(), 5000);
    }

    get boundingClientRect (): DOMRect
    {
        return this.overlayRef.overlayElement.getBoundingClientRect();
    }

    public close (type: PopupTooltipCloseEventType = PopupTooltipCloseEventType.Clicked)
    {
        this.closeEvent.emit(type);
        this._close();
    }

    private destroy ()
    {
        clearTimeout(this.intervalId);
        this.close(PopupTooltipCloseEventType.TimeOut);
    }

    private _close ()
    {
        this.overlayRef.dispose();
    }
}
